import React from 'react';
// import logo from './logo.svg';
import './App.css';
import GetToken from "./Components/GetToken";

function App() {
  return (
    <div className="App">
      <GetToken/>
    </div>
  );
}

export default App;
